import { Component, inject } from '@angular/core';
import { ModalContext } from '../../modal/modal-context';

@Component({
  selector: 'app-upload-result-modal',
  templateUrl: './upload-result-modal.component.html',
  styleUrls: ['./upload-result-modal.component.scss'],
  standalone: false,
})
export class UploadResultModalComponent {
  private readonly modalContext = inject<
    ModalContext<{
      title: string;
      messages: string[];
    }>
  >(ModalContext);

  /** モーダルのタイトル */
  title = this.modalContext.data.title;

  /** 表示させるメッセージ */
  messages = this.modalContext.data.messages;

  /** モーダルを閉じる */
  close() {
    this.modalContext.close();
  }
}
